import styled from "styled-components";
import { Flex } from "../../../../ui";
export const SimpleLegendSymbols = styled(Flex) `
  flex-wrap: nowrap;
  margin: 0 0.75rem;

  img {
    margin: 0 0.5px;
  }
`;
export const SimpleLegendLabel = styled.div `
  font-size: 0.75rem;
  line-height: 0.975rem;
  color: #666;
`;
export const SimpleLegendSquare = styled.div `
  width: 1rem;
  height: 1rem;
  margin: 0 0.5px;
  background-color: #60519ccc;
  opacity: ${({ opacity }) => opacity};
`;
